import { ArrowRight } from "lucide-react";
import { waLink } from "@/lib/whatsapp";
import { trackWhatsAppClick } from "@/lib/analytics";

export const CTABanner = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="container-wide">
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://images.unsplash.com/photo-1573519716358-1cdc98533bfa?crop=entropy&cs=srgb&fm=jpg&w=1400&q=70"
            alt="Coroa de flores 24h Rio de Janeiro — atendimento urgente"
            loading="lazy" decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1F352B]/95 via-[#2D4A3E]/90 to-[#2D4A3E]/70" />

          <div className="relative px-8 py-16 md:px-16 md:py-24 max-w-2xl">
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#BFA573]">
              Atendimento humano · 24h
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mt-3">
              Precisa de uma coroa com urgência?
            </h2>
            <p className="mt-5 text-white/80 leading-relaxed">
              Nossa equipe está disponível agora mesmo. Envie uma mensagem, descreva sua necessidade
              e em poucos minutos confirmamos o pedido com a foto da coroa pronta.
            </p>
            <a
              href={waLink("Olá, preciso de uma coroa de flores com urgência. Podem me ajudar?")}
              target="_blank" rel="noreferrer"
              onClick={() => trackWhatsAppClick("cta_banner")}
              data-testid="cta-banner-whatsapp"
              className="btn-whatsapp mt-8 text-base"
            >
              Pedir agora <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
